export { Airplane as default } from './Airplane';
